module.exports = __webpack_public_path__ + "static/media/donut-logo.0e799daa.png";